const loginRules = {
    userName: [{ required: true, message: "User name is required", validateTrigger: "onSubmit" }],
    password: [{ required: true, message: "Password is required", validateTrigger: "onSubmit" }]
};

export default loginRules;
